import axios from "axios";
import {EnvironmentRegistry} from "./registry/environmentRegistry";
import {AuthContextType, KpiInfo, KpiStatus, KpiWithSchedulerInfo} from "../types/types";
import {get} from "./helpers/restHelpers";
import {pick} from "lodash";


export type KpiCloneRequest = {
    targetLob: string,
    targetEnvironment: string,
    kpiNames: string[]
}

export async function getKpiStatus(authContext: AuthContextType): Promise<KpiStatus> {
    const url = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await axios.get(`${url}/v1/kpi/info/status`, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
    const data = response.data.features as KpiWithSchedulerInfo[]
    data.sort((a, b) => a.kpiInfo.activeStatus === 'inactive' ? 1 : -1);
    const activeKpis = data.filter(info => info.kpiInfo.activeStatus === 'active').length
    const success = data.filter(info => info.schedulerInfo?.extendedAttributes?.status === 'SUCCESS').length
    const failure = data.filter(info => info.schedulerInfo?.extendedAttributes?.status === "FAILURE").length
    return {
        contents: data,
        activeKpis,
        totalKpis: data.length,
        inactiveKpis: data.length - activeKpis,
        success,
        failure
    }
}

export async function updateKpiInfo(kpiInfo: KpiInfo, authContext: AuthContextType): Promise<KpiInfo> {
    // setting default values
    kpiInfo.extractorType = 'SQL';
    kpiInfo.batchSize = 1000;
    const url = EnvironmentRegistry.getUrlFromContext(authContext);
    const response = await axios.put(`${url}/v1/kpi/info`, kpiInfo, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
    return response.data as KpiInfo
}

export async function getKpiInfo(kpiId: string, authContext: AuthContextType): Promise<KpiInfo> {
    const response = await get(`/v1/kpi/info/${kpiId}`, authContext);
    return response.data as KpiInfo;
}

export async function cloneKpis(kpiCloneRequest: KpiCloneRequest, authContext: AuthContextType) {
    return  axios.post(EnvironmentRegistry.getKpiUrl(kpiCloneRequest.targetEnvironment) + "/v1/kpi/clone?env=" +authContext.env, kpiCloneRequest, {
        headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
    })
}


export function getPreFilledKpiInfo(info: KpiInfo) {
    const keysToKeep: any[] = ["description", "extendedAttributes", "target", "executionMode", "extractorType", "batchSize", "aggregationNames", "implementation", "configuration", "targetFilter", "statusEvaluator"];
    return pick(info, keysToKeep) as KpiInfo;
}